import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function HyreachClipperPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-2 text-sm">
            <h5 className="text-[#c41e3a] font-bold">HYREACH CLIPPER</h5>
            <span className="text-gray-400">/</span>
            <h5>
              <Link to="/" className="text-gray-600 hover:text-[#c41e3a]">Home</Link>
            </h5>
          </div>
        </div>
      </section>

      {/* Page Content */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-[#c41e3a] mb-12">Hyreach Clipper</h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Mini Clip */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="w-full h-64 overflow-hidden">
                <img 
                                  src="/images/MC6551_Hero.jpg" 
                  alt="Mini Clip" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <p className="text-lg font-bold text-[#333333] mb-4">Mini Clip</p>
                <Link 
                  to="/mini-clip" 
                  className="inline-block border-2 border-[#333333] text-[#333333] px-6 py-2 text-sm font-bold hover:bg-[#333333] hover:text-white transition-colors whitespace-nowrap"
                >
                  VIEW DETAILS
                </Link>
              </div>
            </div>

            {/* Extreme Duty */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="w-full h-64 overflow-hidden">
                <img 
                                  src="/images/ED64512.jpg" 
                  alt="Extreme Duty" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <p className="text-lg font-bold text-[#333333] mb-4">Extreme Duty</p>
                <Link 
                  to="/extreme-duty" 
                  className="inline-block border-2 border-[#333333] text-[#333333] px-6 py-2 text-sm font-bold hover:bg-[#333333] hover:text-white transition-colors whitespace-nowrap"
                >
                  VIEW DETAILS
                </Link>
              </div>
            </div>

            {/* Teleclipper */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="w-full h-64 overflow-hidden">
                <img 
                                  src="/images/664-ED02.jpg" 
                  alt="Teleclipper" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <p className="text-lg font-bold text-[#333333] mb-4">Teleclipper</p>
                <Link 
                  to="/teleclipper" 
                  className="inline-block border-2 border-[#333333] text-[#333333] px-6 py-2 text-sm font-bold hover:bg-[#333333] hover:text-white transition-colors whitespace-nowrap"
                >
                  VIEW DETAILS
                </Link>
              </div>
            </div>

            {/* Clampit */}
            <div className="bg-white rounded-lg overflow-hidden shadow-md">
              <div className="w-full h-64 overflow-hidden">
                <img 
                                  src="/images/C688HC.jpg" 
                  alt="Clampit" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <p className="text-lg font-bold text-[#333333] mb-4">CLAMPit</p>
                <Link 
                  to="/clampit" 
                  className="inline-block border-2 border-[#333333] text-[#333333] px-6 py-2 text-sm font-bold hover:bg-[#333333] hover:text-white transition-colors whitespace-nowrap"
                >
                  VIEW DETAILS
                </Link>
              </div>
            </div>

            
            
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer 
        className="bg-cover bg-center relative py-16"
              style={{ backgroundImage: 'url(/images/scaled.jpg)'}}
      >
        <div className="absolute inset-0 bg-[#003d5c]/95"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
            <div>
              <img 
                              src="/images/lagoos.png" 
                alt="AgriWorks Logo" 
                className="h-24 mb-4"
              />
              <h6 className="text-sm mb-4">
                Powered by AgriWorks<br />
                
                <a href="tel:6812968160" className="hover:underline">(681) 296-8160</a>
              </h6>
              
              
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Contact</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="mailto:jolyn.consult@hotmail.com" className="hover:underline">Email: jolyn.consult@hotmail.com</a>
                </li>
                <li>
                  <a href="tel:6812968160" className="hover:underline">Phone: (681) 296-8160</a>
                </li>
                <li>23 Margaret Dr, Somerset, NJ 08873</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Links</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/products" className="hover:underline">Products</Link>
                </li>
                
                <li>
                  <Link to="/contact" className="hover:underline">Contact Us</Link>
                </li>
                
              </ul>
            </div>

            <div>
              <img 
                              src="/images/made-in-the-usa.webp" 
                alt="Made in USA" 
                className="w-48 mb-4"
              />
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/80">
                      <p>© {new Date().getFullYear()} AgriWorks Manufacturing LLC. All rights reserved. </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
